import { Component, OnInit, Input, DoCheck, Optional, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { UtilityService } from '../../Shared/services/UtilityService';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { CheckBoxOptions } from '../../Shared/Models/CheckBoxOptions';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'BBSF-CheckBox',
  templateUrl: './CheckBox.component.html',
  styleUrls: ['./CheckBox.component.scss']
})
export class CheckBoxComponent implements OnInit {


  static controlContainerstatic = null;
  // tslint:disable-next-line: max-line-length
  constructor(private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public CheckBoxControlHost: FormGroupDirective) {
    CheckBoxComponent.controlContainerstatic = this.controlContainer;
  }
  @Input() group: FormGroup;
  @Input() options: CheckBoxOptions;
  @Output() OnChange = new EventEmitter();

  CheckBoxFormControl: AbstractControl;
  markAllAsTouched: boolean = false;
  validationRules = [];
  validationRulesasync = [];
  ngOnInit() {
    UtilityService.isCreatedBefor = false
    this.group.addControl(this.options.Name, new FormControl(''));
    this.CheckBoxFormControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);
    this.validationRules = [];
    this.validationRulesasync = [];
    this.CheckBoxFormControl.setValue(this.options.Value);
    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);


    if (this.options.IsRequired) {
      this.validationRules.push(Validators.required);
    }
    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.validationRules.push(Validation.functionBody);
      }

    }


    this.CheckBoxFormControl.setValidators(this.validationRules);
    this.CheckBoxFormControl.setAsyncValidators(this.validationRulesasync);
    if (this.options.IsDisabled) {
      this.CheckBoxFormControl.disable();
    }

    this.CheckBoxControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })


  }


  ngAfterViewInit(): void {
    this.controlUtility.setAttributeForControl(this.options)
  }

  resetError = () => {
    UtilityService.RemoveGlobalError();
  }



  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }
    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }

  onValueChanged() {
    this.OnChange.emit(this.CheckBoxFormControl.value)
  }

  //External Method
  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.CheckBoxFormControl, this.validationRules, this.options)
  }
  //External Method
  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.CheckBoxFormControl, this.validationRules, this.options)
  }

  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.CheckBoxFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.CheckBoxFormControl, this.validationRules, CustomValidation)
  }

  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.CheckBoxFormControl)
  }

}

